import React from 'react';
import { CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { plans } from '../data/content';
export function FinalCta() {
  return <section className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="cierre-title" data-id="element-84" data-mp="19cmb4bkwfpdi">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="1jcvb80i0huy6">
        <h2 id="cierre-title" className="sr-only" data-id="element-86" data-mp="1jbtxtpdiwwda">
          Última oportunidad al precio de lanzamiento
        </h2>

        <CountdownTimer heading="⏰ El precio cierra en:" data-id="element-87" data-mp="1eds66g217oq7" />

        <div className="mt-8 grid gap-5 md:grid-cols-2" data-id="element-88" data-mp="1t37uzqi05k39">
          {plans.map(plan => <article key={plan.id} className={`flex flex-col rounded-3xl border p-6 sm:p-8 ${plan.featured ? 'border-gold bg-surface shadow-gold' : 'border-line bg-surface'}`} data-id="element-89" data-mp="1o3brrth4pwor">
              <h3 className="text-lg font-extrabold leading-tight tracking-tight text-white sm:text-xl" data-id="element-90" data-mp="n5ujxwb6dde4">
                <span aria-hidden="true" data-id="element-91" data-mp="s45uyad7htxx">{plan.emoji}</span> {plan.name}
                {plan.featured ? <span className="ml-1.5" aria-hidden="true" data-id="element-92" data-mp="x3ipzie8e7bl">
                    ⭐
                  </span> : null}
              </h3>
              <p className="mt-2 text-sm text-neutral-400" data-id="element-93" data-mp="120sdgsi288ws">{plan.includes}</p>
              <div className="mt-5 flex flex-wrap items-baseline gap-3" data-id="element-94" data-mp="163xcgl2xlsgo">
                <span className="text-base text-neutral-600 line-through" data-id="element-95" data-mp="1b2i3btwamzsg">
                  {plan.oldPrice}
                </span>
                <span className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-96" data-mp="1fv1rtlwirfc1">
                  {plan.price}
                </span>
              </div>
              <div className="mt-6 flex-1" data-id="element-97" data-mp="1pth80tu0d46r" />
              <CtaButton href={plan.checkoutUrl} trackingLabel={plan.name} variant={plan.featured ? 'primary' : 'outline'} data-id="element-98" data-mp="1pqmod4itjnee">
                {plan.cta}
              </CtaButton>
            </article>)}
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs font-medium text-neutral-500" data-id="element-99" data-mp="3lxf6lbjzobzg">
          <li className="inline-flex items-center gap-1.5" data-id="element-100" data-mp="3uwahh0xzaa93">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-101" data-mp="3uupimz4ms55f" />
            Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="dhvkqxlndvuf">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-103" data-mp="8fmp1the4fom" />
            Acceso en 5 minutos
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-104" data-mp="mf5xyoi0zv1z">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-105" data-mp="if5887ph7xfm" />
            Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-106" data-mp="2o727jskmuuu4">
            <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-107" data-mp="2o9n90gh0r8rc" />
            Mercado Pago | Tarjeta | Transferencia
          </li>
        </ul>
      </div>
    </section>;
}